import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5128298"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap" }
const _hoisted_2 = { class: "flex-equal me-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, "PERSONAL", -1))
const _hoisted_4 = { class: "table table-flush fw-semobold gy-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "First Name", -1))
const _hoisted_6 = { class: "text-gray-800" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Last Name", -1))
const _hoisted_8 = { class: "text-gray-800" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Nationality", -1))
const _hoisted_10 = { class: "text-gray-800" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Sex", -1))
const _hoisted_12 = { class: "text-gray-800" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Date of Birth", -1))
const _hoisted_14 = { class: "text-gray-800" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Address", -1))
const _hoisted_16 = { class: "text-gray-800" }
const _hoisted_17 = { class: "flex-equal" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, "DOCUMENT", -1))
const _hoisted_19 = { class: "table table-flush fw-semobold gy-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-225px" }, "Document Type", -1))
const _hoisted_21 = { class: "text-gray-800" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-225px" }, "Document Number", -1))
const _hoisted_23 = { class: "text-gray-800" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-225px" }, "Document Country", -1))
const _hoisted_25 = { class: "text-gray-800" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-225px" }, "Document Expiry", -1))
const _hoisted_27 = { class: "text-gray-800" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1))
const _hoisted_29 = { class: "row g-5 g-xl-10 px-3 px-xl-6 pb-3 pb-xl-6 justify-content-center" }
const _hoisted_30 = { class: "col-6 image-section" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, "LIVE SELFIE", -1))
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = { class: "col-6 image-section" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, "DOCUMENT FRONT", -1))
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "separator" })
], -1))
const _hoisted_37 = {
  key: 0,
  class: "col-6 image-section"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, "DOCUMENT BACK", -1))
const _hoisted_39 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.first_name), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.last_name), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.meta?.nationality || _ctx.country), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_11,
              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.sex), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.meta?.date_of_birth || _ctx.form.date_of_birth || "N/A"), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_15,
              _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.form.address || "N/A"), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("table", _hoisted_19, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_20,
              _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.form?.doc_type !== null ? _ctx.KYCDocTypes[_ctx.form.doc_type] : "N/A"), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.meta?.number || _ctx.form?.id_number || "N/A"), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_24,
              _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.country), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_26,
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.meta?.expiration_date || "N/A"), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        (_ctx.selfie)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.selfie.src,
              alt: _ctx.selfie.alt_text,
              class: "img-fluid"
            }, null, 8, _hoisted_32))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        (_ctx.frontDoc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.frontDoc.src,
              alt: _ctx.frontDoc.alt_text,
              class: "img-fluid"
            }, null, 8, _hoisted_35))
          : _createCommentVNode("", true)
      ]),
      _hoisted_36,
      (_ctx.backDoc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _hoisted_38,
            (_ctx.backDoc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.backDoc.src,
                  alt: _ctx.backDoc.alt_text,
                  class: "img-fluid"
                }, null, 8, _hoisted_39))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}